// socket.js
import { io } from 'socket.io-client';
import { KTC_API_URL_SOCKET } from '../constants/api';
//console.log('KTC_API_URL_SOCKET:', KTC_API_URL_SOCKET);
const socket = io(KTC_API_URL_SOCKET, {
  withCredentials: true,
  transports: ['websocket'], // optional, for stability
});
//console.log('Socket connected:', socket.id);

export default socket;
